import React from 'react'
import DrawingCanvasItem from './DrawingCanvasItem'

const _ = require('lodash')

class Drawing extends React.Component {
  getPixelSize() {
    return 320
  }

  renderDrawingSquares() {
    const squaresAcross = Math.sqrt(this.props.squaresCount)

    const squareSize = this.getPixelSize() / squaresAcross

    const style = {
      width: `${squareSize}px`,
      height: `${squareSize}px`,
      display: 'inline-block',
    }
    const zoom = squareSize / 320

    const drawingSquares = _.range(1, this.props.squaresCount + 1).map((i) => {
      const drawingSquare = _.find(this.props.drawingSquares, {
        drawing_squareNumber: `${this.props.drawingId}_${this.props.drawingIndex}_${i}`,
      })
      const className = drawingSquare ? 'drawing-square--done' : 'drawing-square'
      return (
        <DrawingCanvasItem
          key={`square-container-${i}`}
          id={i}
          style={style}
          className={className}
          onClickHandler={this.props.onSelectSquare}
          drawingSquare={drawingSquare}
          squaresCount={this.props.squaresCount}
          zoom={zoom}
          drawingMode={false}
        />
      )
    })

    return drawingSquares
  }

  render() {
    const styles = {
      backgroundImage: `url('${this.props.imageUrl}')`,
      backgroundSize: '100%',
      width: this.getPixelSize(),
      height: this.getPixelSize(),
    }
    return (
      <div className="drawing" style={styles}>
        {this.renderDrawingSquares()}
      </div>
    )
  }
}

export default Drawing



// WEBPACK FOOTER //
// ./src/components/Drawing.js